/* Luvlyn · beweging (port van js/beweging.js uit de ontwerpsite, 03-10-2026; de teksten van het
   speler-pop-upje komen uit de taalbestanden via Luvlyn.tekst)
   De animaties en moderne interactie uit home V2, op het design van de home (zie css/beweging.css).
   - binnenkomen bij het scrollen: groepen (kaarten, cellen) komen na elkaar binnen,
     losse koppen en teksten per variant op volgorde. Ook in een variant die je later
     opent: die komt binnen zodra hij in beeld is.
   - de kop: glas zodra de balk uit beeld is; op mobiel de snelle links weg na de hero
   - het mandje springt op bij "in winkelwagen"
   - het speler-pop-upje linksonder: stoppen terwijl je verder kijkt
   Geen scroll-listeners: alles via IntersectionObserver. Bij prefers-reduced-motion geen
   binnenkomen (alles staat er meteen). */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const stil = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const T = (window.Luvlyn && window.Luvlyn.tekst) || {};

  /* ---------- binnenkomen ---------- */
  // groepen: de kinderen komen na elkaar binnen zodra de groep in beeld komt
  // [data-toon-groep] en [data-toon]: hetzelfde voor andere pagina's (product.html), zonder de lijst te verlengen
  const GROEPEN = '.bw1, .kk1-rij, .kk4-rij, .vd1-rij, .vd6-bento, .vd7-lijst, .lu4-rij, .lu-a-rij, .lu6-harmonica, .vt1-grid, [data-toon-groep]';
  // los: per variant op volgorde (kop, dan tekst, dan de rest). Niet .vt-onder (30-09, avond): die staat
  // helemaal onderaan en kwam door de marge van -8% nooit in beeld, dus bleef hij onzichtbaar.
  const LOS = '.bw6-sterren, .bw6-zin, .bw6-bron, .bw6-rechts, .sectie:not(.vast) .h2, .sectie:not(.vast) .lead, .sectie:not(.vast) .kicker, .kk-onder, .schuif-nav, .rv4, .rv3-band, .rv6-kop .rv4-score, .rv6-wand, .fq4-mail, .fq4-l > .pijl-link, .lu6-meer, .vd7-beeld, .vd7-cijfers, .fq4-venster, .fq2-kaart, .fq-lijst, [data-toon]';
  if (!stil && 'IntersectionObserver' in window){
    const alles = `${GROEPEN}, ${LOS}`;
    const doelen = new Map();
    $$(GROEPEN).forEach(g => {
      const kinderen = [...g.children];
      kinderen.forEach((k, i) => { k.classList.add('toon'); k.style.setProperty('--i', Math.min(i, 6)); });
      doelen.set(g, kinderen);
    });
    const teller = new Map();
    $$(LOS).forEach(el => {
      if (el.parentElement.closest(alles)) return;       // zit al in iets dat binnenkomt
      const v = el.closest('.variant') || document.body;
      const i = teller.get(v) || 0;
      teller.set(v, i + 1);
      el.classList.add('toon');
      el.style.setProperty('--i', Math.min(i, 4));
      doelen.set(el, [el]);
    });
    const zie = new IntersectionObserver(items => items.forEach(item => {
      if (!item.isIntersecting) return;
      doelen.get(item.target).forEach(el => el.classList.add('zicht'));
      zie.unobserve(item.target);
    }), { rootMargin: '0px 0px -8% 0px', threshold: .1 });
    doelen.forEach((_, el) => zie.observe(el));
  }

  /* ---------- de kop ---------- */
  const kop = $('.sectie[data-id="kop"]');
  const balk = $('.sectie[data-id="balk"]');
  const hero = $('.sectie[data-id="hero"]') || $('[data-hero]');   // op de productpagina: galerij en koopblok
  if (kop && balk) new IntersectionObserver(([item]) => kop.classList.toggle('gescrold', !item.isIntersecting)).observe(balk);
  if (kop && hero) new IntersectionObserver(([item]) => kop.classList.toggle('voorbij', !item.isIntersecting), { rootMargin: '-120px 0px 0px 0px' }).observe(hero);

  /* ---------- het speler-pop-upje (Cehdi, 30-09) ----------
     Speelt er een geluid en is de knop waarmee je het startte uit beeld (weggescrold), dan
     schuift linksonder een pilletje in met de naam en een stopknop. Na stoppen, als het
     geluid afloopt of als je terugscrolt naar de knop, gaat het weer weg. De spelers in
     hero.js en secties.js geven een seintje ('geluid') met wie, speelt, naam, bron en stop. */
  const speler = document.createElement('div');
  speler.className = 'speler';
  speler.setAttribute('role', 'region');
  speler.setAttribute('aria-label', T.spelerRegio || '');
  speler.innerHTML = '<span class="lu-golf" aria-hidden="true">' + '<i></i>'.repeat(7) + '</span>'
    + `<span class="speler-tekst"><small>${T.spelerNu || ''}</small><b data-speler-naam></b></span>`
    + `<button class="speler-stop" type="button" aria-label="${T.spelerStop || ''}"><svg class="ic vol"><use href="#i-stop"/></svg></button>`;
  document.body.append(speler);
  let huidig = null, inBeeld = true;
  const kijk = new IntersectionObserver(([item]) => { inBeeld = item.isIntersecting; werkBij(); }, { threshold: .2 });
  function werkBij(){
    const aan = !!huidig && !inBeeld;
    speler.classList.toggle('aan', aan);
    speler.classList.toggle('speelt', aan);
    document.body.classList.toggle('met-speler', aan);
  }
  document.addEventListener('geluid', ({ detail: d }) => {
    if (d.speelt && d.bron){
      if (!huidig || huidig.bron !== d.bron){ if (huidig) kijk.unobserve(huidig.bron); inBeeld = true; kijk.observe(d.bron); }
      huidig = d;
      $('[data-speler-naam]', speler).textContent = d.naam;
    } else if (huidig && huidig.wie === d.wie){
      kijk.unobserve(huidig.bron);
      huidig = null;
    }
    werkBij();
  });
  $('.speler-stop', speler).addEventListener('click', () => { if (huidig) huidig.stop(); });

  /* ---------- het mandje springt op ---------- */
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-in-mand]')) return;
    $$('.ic-knop.mand').forEach(m => { m.classList.remove('hup'); void m.offsetWidth; m.classList.add('hup'); });
  });
})();
